module.exports = __webpack_public_path__ + "static/media/angle-left.581b1c12.svg";